package com.cybergstudios.rtc.world

import com.cybergstudios.rtc.engine.Color
import com.cybergstudios.rtc.math.Vec2

/**
 * Polygons represent objects on the screen.
 *
 * We render them using the points that should be listed in clockwise order.
 *
 * The main rectangle is an optimization for collision detection.
 *
 * The list of rectangles are used for collision detection.
 *
 * If the Polygon is not enabled it won't be rendered or used during collision detection.
 */
data class Polygon(
    val points: List<Vec2>,
    val mainRectangle: Rectangle,
    val rectangles: List<Rectangle>,
    val color: Color,
    var enabled: Boolean,
) {
    fun scale(v: Double): Polygon {
        val newPoints = points.map { it.scale(v) }
        val newMainRectangle = mainRectangle.scale(v)
        val newRectangles = rectangles.map { it.scale(v) }
        return Polygon(newPoints, newMainRectangle, newRectangles, color, enabled)
    }

    fun add(v: Vec2): Polygon {
        val newPoints = points.map { it.add(v) }
        val newMainRectangle = mainRectangle.add(v)
        val newRectangles = rectangles.map { it.add(v) }
        return Polygon(newPoints, newMainRectangle, newRectangles, color, enabled)
    }

    fun hit(): Int {
        enabled = false
        return 10 // TODO: make it a part of the constructor
    }
}